import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-white dark:bg-[#0c1427] p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "mb-8 sm:mb-12" }
const _hoisted_3 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 auto-rows-fr" }
const _hoisted_4 = {
  class: "group animate-fade-in-up transition-all duration-500 hover:scale-[1.02] hover:-translate-y-1 h-full",
  style: {"animation-delay":"0.1s"}
}
const _hoisted_5 = {
  class: "group animate-fade-in-up transition-all duration-500 hover:scale-[1.02] hover:-translate-y-1 h-full",
  style: {"animation-delay":"0.2s"}
}
const _hoisted_6 = {
  class: "group animate-fade-in-up transition-all duration-500 hover:scale-[1.02] hover:-translate-y-1 h-full w-full",
  style: {"animation-delay":"0.3s"}
}
const _hoisted_7 = { class: "mb-8 sm:mb-12" }
const _hoisted_8 = {
  class: "relative group animate-fade-in-up transition-all duration-500 hover:scale-[1.01] hover:-translate-y-1",
  style: {"animation-delay":"0.4s"}
}
const _hoisted_9 = {
  class: "animate-fade-in-up transition-all duration-500",
  style: {"animation-delay":"0.5s"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RevenueGrowthChart = _resolveComponent("RevenueGrowthChart")!
  const _component_AnnualProfitChart = _resolveComponent("AnnualProfitChart")!
  const _component_LeadConversionChart = _resolveComponent("LeadConversionChart")!
  const _component_BalanceOverviewChart = _resolveComponent("BalanceOverviewChart")!
  const _component_RecentLeads = _resolveComponent("RecentLeads")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_RevenueGrowthChart)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_AnnualProfitChart)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_LeadConversionChart)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_BalanceOverviewChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_RecentLeads)
    ])
  ]))
}